import {IErrorField} from "../../Basic/api";
import {Moment} from "moment";
import {IInitiateDataChangeData} from "./backend";
import {DataForChange} from "../../../enum/personalInfo";

export interface IChangeDataModal {
    type: DataForChange | null,
    dataForChange: IInitiateDataChangeData | null
    opened: boolean
    success: boolean
}

export const ChangeDataModalInit = {
    dataForChange: null,
    type: null,
    opened: false,
    success: false,
}

export interface IAccountState {
    personalInfo: IPersonalInfo
    socialNumber: ISocialNumber | null
    passport: IPassport | null
    foreign_passport: IForeignPassport | null
    gender: ISex[]
    error: IErrorField
    citizenship: ICitizenship[] | []
    identityCardType: number | null
    identityCardTypes: IIdentityCardType[]
    avatar: IAvatar | null
    phone: string | null
    email: string | null
    codePending: boolean
    retryAfter: number | null
    isSecurityInputSend: boolean
    isCodeRight: boolean
    passwordDate: string | null
    smsPending: boolean
    addAvatar: boolean
    works: IWork[] | null
    educations: IEducation[] | null
    worksPending: boolean
    educationsPending: boolean
    tabClick: boolean
    isFetching: boolean
    needUpdate: boolean
    changeDataModal: IChangeDataModal
    externalAccountsData: ExternalAccountsData | null
}

export interface IUserState {
    error: IErrorField
    isFetching: boolean
    setChangeSuccess: boolean
    setSmsPend: boolean
    setChangeDataForChange: IInitiateDataChangeData | null
}

export interface IWork {
    id: number
    number: string
    name: string
}

export interface IEducation {
    id: number
    number: string
    name: string
}

export interface IPersonalInfo {
    name: string
    surname: string
    patronymic: string | null
    birthdate: Moment | null
    sex_id: number | null
    sex: ISex | null
}

export interface ISocialNumber {
    value: string
    is_verified: boolean
}

export interface ISex {
    id: number
    name: string
}

interface IMessage {
    success: string | null
    error: string | null
}

interface ISber {
    client_id: string;
    state: string;
    nonce: string;
    redirect_uri: string;
    scope: string;
    response_type: string;
    client_type: string;
  }

export interface ExternalAccount {
    name: string;
    connected: boolean;
    url: string | null;
    message: IMessage;
    sber?: ISber;
    alias: string;
    isDeletable: boolean;
  }
  
 export interface ExternalAccountsData {
    data: ExternalAccount[]
  }

export interface IIdentityCard {
    id: number
    person_id: string
    identity_card_type_id: number
    identityCardType: {
        id: number
        name: string
    }
    citizenship_id: number
    citizenship: {
        id: number
        name: string
    }
    number: string
    issued_at: Moment
    is_verified: boolean
    outdated: Moment,
    isOutdated: boolean
}

export interface IPassport extends IIdentityCard {
    series: string
    issued_by: string
    department_code: string
}

export interface IForeignPassport extends IIdentityCard {
    expires_at: Moment
}

export interface ICitizenship {
    id: number
    name: string
}

export interface IIdentityCardType {
    id: number
    name: string
}

export interface IAvatar {
    id: number
    path: string
}
